import React from 'react';

export const PowerfulFeaturesHeader = () => (
  <>
    {/* Powerful Features */}
    <div
      style={{
        position: 'absolute',
        width: 530,
        height: 76,
        left: 471,
        top: 1504,
        fontFamily: `'SF Pro', sans-serif`,
        fontStyle: 'normal',
        fontWeight: 510,
        fontSize: 64,
        lineHeight: '76px',
        color: '#FFFFFF',
      }}
    >
      Powerful Features
    </div>

    {/* Rectangle 6 (подчёркивание) */}
    <div
      style={{
        position: 'absolute',
        width: 496,
        height: 8,
        left: 472,
        top: 1582,
        background: 'linear-gradient(90deg, #6D1D7D 0%, #5F0BE8 100%)',
        borderRadius: 50,
      }}
    />

    {/* Подзаголовок */}
    <div
      style={{
        position: 'absolute',
        width: 385,
        height: 141,
        left: 'calc(50% - 385px / 2 - 0.5px)',
        top: 1629,
        fontFamily: `'SF Pro', sans-serif`,
        fontStyle: 'normal',
        fontWeight: 510,
        fontSize: 24,
        lineHeight: '29px',
        textAlign: 'center',
        color: 'rgba(255, 255, 255, 0.6)',
      }}
    >
      Everything you need for successful trading analysis
    </div>
  </>
);